import wallet from '~/pages/wallet2/wallet'
import Wallet2PayPal from '~/pages/wallet2/PayPal/reducers'
import Wallet2Payoneer from '~/pages/wallet2/payoneer/reducers'
import Wallet2Pandapay from '~/pages/wallet2/PandaPay/reducers'
import Wallet2Stripe from '~/pages/wallet2/stripe/reducers'
import Wallet2Checkout from '~/pages/wallet2/checkout/reducers'

export default {
  wallet,
  Wallet2PayPal,
  Wallet2Payoneer,
  Wallet2Pandapay,
  Wallet2Stripe,
  Wallet2Checkout,
}
